import { useLocation } from 'react-router-dom';
import React, {useEffect, useState, useContext} from 'react';
import PropTypes from 'prop-types';
import styles from './TopNav.module.scss';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import Container from "react-bootstrap/Container";
import {Navbar, Nav, Dropdown} from "react-bootstrap";
import logo from "../../../images/careorbitLogo.svg";
import {Avatar} from "@material-ui/core";
import {
  getUser, setUser
} from "../../../helpers/index.js";
import {userProfile} from "../../../actions/userProfile.js";
import {useDispatch, useSelector, shallowEqual} from "react-redux";
import {logout} from "../../../middleware/auth/index.js";
import {useNavigate, useParams} from "react-router-dom";
import styled from 'styled-components'

import Select from "@material-ui/core/Select/Select.js";
import {SERVICE_LINE_ADMIN, ORBIT_ADMIN, ORGANIZATION_ADMIN, REGULAR_USER, SYS_ADMIN, isProfessional, isPublicUser} from "../../../constants/roles.js";
import {diagnosesList} from "../../../actions/diagnosisList.js";
import {diagList} from "../../../actions/diagList.js";
import {
  setDefaultOrbit,
  setDiagnosticFilterList,
  setDiagnosticId,
  setDiagnosticList,
  setDisplayDiagnostics,
  setDisplayTiles,
  setHome,
  setNavigateToHomePage,
  setOrbitList,
  setRefreshTileAttributeList,
  setDisplayServiceLine,
  setServiceLineList,
  setServiceLineId,
  setInitialTopNavDisplay,
  setDisplayOrganization,
  setOrganizationList,
  setHideTopNav,
  setDisplayOrbit,
  setOrganizationId, setSelectOrbit
} from "../../../actions/home.js";
import {orbit} from "../../../actions/orbit.js";
import {orbitClusterTileList} from "../../../actions/orbitClusterTileList.js";
import {HOME, UPDATE_LOGO} from "../../../actions/types.js";
import {orbitById} from "../../../actions/orbitById.js";
import {AppContext} from "../../../context/AppContext";
import {serviceLineList} from "../../../actions/serviceLineList";
import {orgList} from "../../../actions/orgList";
import {userOrbitOrgPopulateAndDisplay} from "../../common/home/index";
import {useProfilePhoto} from "../../../hooks/useProfilePhoto.js";
//adding to force a push

const TopNav = () => {
  let user = getUser();
  const [imageUrl, setImageUrl] = useState('');
  const profilePhoto = useProfilePhoto(imageUrl);
  const [loaded, setLoaded] = useState(false);
  const [orgProfileImage, setOrgProfileImage] = useState(null);
  const [imageSet, setImageSet] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [isPatient, setIsPatient] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [displayUserInvite, setDisplayUserInvite] = useState(false);
  const [displayPatientInvite, setDisplayPatientInvite] = useState(false);
  const [displayDropDowns, setDisplayDropDowns] = useState(false);
  const [displayServiceLineDropDowns, setDisplayServiceLineDropDowns] = useState(false);
  const [displayOrganizationDropDowns, setDisplayOrganizationDropDowns] = useState(false);
  const [showNewOrbit, setShowNewOrbit] = useState(false);
  const [displayAdminPanelLink, setDisplayAdminPanelLink] = useState(false);
  const [termsConditionsShowHide, setTermsConditionsShowHide] = useState(false);
  let selectedOrbit = '';
  let selectedDiagnosisId = [];
  const location = useLocation();
  const {logout} = React.useContext(AppContext);

  const {
    diagnosticId,
    defaultOrbit,
    orbitList,
    diagnosticList,
    diagnosticFilterList,
    displayTiles,
    initialTopNavDisplay,
    navigateToHomePage,
    serviceLineId,
    serviceLineList,
    organizationId,
    organizationList,
    hideTopNav,
    tileAttributes
  } = useSelector(state => {
      user = getUser();
      return state.home;
  });

  const {
    bodyCss,

  } = useSelector(state => state.logo);

  const {
    userProfileImage
  } = useSelector(state => {
    return state.userProfile;
  });

  /*const {defaultOrbit} = useSelector(state => {
    user = getUser();
    return state.orbit
  });*/
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const logoutUser = (e) => {
    e.preventDefault();
    const logoutFunc = logout(false)(navigate);
    dispatch(logoutFunc);
  }

  const goToAdminPanel = (e) => {
    e.preventDefault();
    window.open('https://admin.careorbit.health/login', 'top');
  }

  const selectNewOrbit = (e) => {
    (async () => {
      dispatch(setDefaultOrbit(null));
      user.defaultOrbit = null;
      setUser(user);
      dispatch(setHome({
        tileAttributes: null,
        clusterCssArray: null,
        clusterType: 0,
        useFlexContainer: null
      }));
      dispatch(setDisplayTiles(false));
      dispatch(setDisplayOrganization(false));
      dispatch(setDisplayServiceLine(false));
      dispatch(setDisplayOrbit(false));
      dispatch(setHideTopNav(true));
      dispatch(setInitialTopNavDisplay(false));
      dispatch(setServiceLineList([]));
      dispatch(setOrbitList([]));
      dispatch(setOrganizationList([]));
      dispatch(setOrganizationId(null));
      dispatch(setServiceLineId(null));
      userOrbitOrgPopulateAndDisplay(dispatch)(setTermsConditionsShowHide)(user)(organizationList)(organizationId);
      dispatch(setSelectOrbit(true));
      navigate('/');

      if ((defaultOrbit && defaultOrbit.length > 0) ||
          (user?.defaultOrbit && user?.defaultOrbit.length > 0)) {
        dispatch(setHideTopNav(false));
      } else {
        dispatch(setHideTopNav(true));
      }
    })()
    /*
    e.preventDefault();
    if (user?.organizations && user?.organizations?.length > 0) {
      dispatch(setOrganizationList(user?.organizations.map((organization) => ({
        organizationId: organization.organizationId,
        orgName: organization.orgName
      }))));

    } else if (user?.orbits && user?.orbits?.length > 0) {
      dispatch(setOrbitList(user?.orbits.map((orbit) => ({
        organizationId: orbit.organizationId,
        orgName: orbit.orgName
      }))));
    }

    debugger;
    debugger;
    debugger;
    dispatch(setDefaultOrbit(null));
    user.defaultOrbit = null;
    setUser(user);
    dispatch(setHome({
      tileAttributes: null,
      clusterCssArray: null,
      clusterType: 0,
      useFlexContainer: null
    }));
    dispatch(setDisplayTiles(false));
    dispatch(setDisplayOrganization(false));
    dispatch(setDisplayServiceLine(false));
    dispatch(setDisplayOrbit(false));
    dispatch(setHideTopNav(false));
    dispatch(setInitialTopNavDisplay(false));
    dispatch(setServiceLineList([]));
    dispatch(setOrbitList([]));
    dispatch(setOrganizationList([]));
    dispatch(setOrganizationId(null));
    navigate('/');
     */
  }

  useEffect(() => {
    if (defaultOrbit && defaultOrbit.length > 0) {
      if (isProfessional(user?.roles)) {
        setDisplayPatientInvite(true);
        setDisplayUserInvite(true);
        setDisplayOrganizationDropDowns(true);
        setDisplayServiceLineDropDowns(true);
        setIsAdmin(true);
      }

      if (defaultOrbit && defaultOrbit.length > 0) {
        setInitialTopNavDisplay(true);
      }
    }
  }, [defaultOrbit, tileAttributes]);

  useEffect(() => {
    setImageUrl(userProfileImage);
  }, [userProfileImage])

  useEffect(() => {
    setFirstName(user?.firstName);
    setLastName(user?.lastName);
    setShowNewOrbit(user?.orbits?.length > 1 || user?.organizations?.length > 0 || user?.isSysAdmin);
    setDisplayAdminPanelLink(user?.isSysAdmin || isProfessional(user?.roles))
  }, [])

  useEffect(() => {
    (() => {
      setImageUrl(user?.imageUrl);
      if (defaultOrbit && defaultOrbit.length > 0) {
        if (isPublicUser(user?.roles)) {
          setDisplayPatientInvite(false);

          if (user?.relation && user?.relation > 0)
            setDisplayUserInvite(false);
          else
            setDisplayUserInvite(true);

          setIsAdmin(false);
        }
      }
    })()
  })

  if (!hideTopNav) {
    return (
        <div className={styles.Nav} key="navOuterContainer">
          <Navbar className="navbarLoggedIn" bg="white" variant="light" expand="lg">
            <Container className="navContainer" key="navNavBarContainer">
              <div className="navLogoContainer" key="navLogoContainer">
                <Navbar.Brand href="/">
                  <img className="brandLogo" style={{"visibility": loaded ? "visible" : "hidden"}} alt="logo"
                       src={orgProfileImage}/>
                </Navbar.Brand>
              </div>
              <Navbar.Toggle aria-controls="basic-navbar-nav"/>
              <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end loggedInNav">
                <Nav>
                  <Nav.Link href="mailto:support@careorbit.health" className="text-dark">Help</Nav.Link>
                  {
                    // isPatient && <Nav.Link className="text-dark" href="/userinvite">Invite Family</Nav.Link>
                  }
                  {
                      // (initialTopNavDisplay && user?.isSysAdmin) &&
                      user?.isSysAdmin && false &&
                      <Nav.Link href="/generateQrCodeUrl" className="text-dark">QR Code URL</Nav.Link>
                  }
                  {
                      displayUserInvite && <Nav.Link className="text-dark"
                                                     href="/userinvite">{isAdmin ? "Invite Admin" : "Invite Family"}</Nav.Link>
                  }
                  {
                      displayPatientInvite &&
                      <Nav.Link className="text-dark" href="/patientinvite">Invite Patient</Nav.Link>
                  }
                  {
                      showNewOrbit &&
                      <Nav.Link className="text-dark" onClick={selectNewOrbit}>Orbit Guide</Nav.Link>
                  }
                  {
                      displayAdminPanelLink &&
                      <Nav.Link className="text-dark" onClick={goToAdminPanel}>Admin Tools</Nav.Link>
                  }
                  <Nav.Link className="text-dark" onClick={logoutUser}>
                    Logout
                  </Nav.Link>
                  {user && user?.isTemporaryOrbitAccessUser ?
                      <div className="profileContainer"
                           style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                        <div className="avatarContainer" style={{height: 36}}>
                          <Avatar
                              alt={lastName + ', ' + firstName}
                              src={profilePhoto || undefined}
                              name="previewImage"
                              id="previewImage"
                              className="previewImage"
                          />
                          <div className="userName" style={{marginBottom: "0px", color: "#000000"}}>
                            {firstName}
                          </div>
                        </div>
                      </div> :
                      <Nav.Link className="text-dark profileContainer" href="/profile">
                        <div className="avatarContainer">
                          <Avatar
                              alt={lastName + ', ' + firstName}
                              src={profilePhoto || undefined}
                              name="previewImage"
                              id="previewImage"
                              className="previewImage"
                          />
                          <div className="userName" style={{marginBottom: "0px"}}>
                            {firstName}
                          </div>
                        </div>
                      </Nav.Link>
                  }
                </Nav>
              </Navbar.Collapse>
            </Container>
          </Navbar>
        </div>
    );
  } else {
    return '';
  }
};

export default TopNav;
